/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_User_Not_AdministrableInputs */

const en_error_user_not_administrable = /** @type {(inputs: Error_User_Not_AdministrableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You administer the users of the customers with the roles of Frontrow: an administrator changes this user.`)
};

/**
* | output |
* | --- |
* | "You administer the users of the customers with the roles of Frontrow: an administrator changes this user." |
*
* @param {Error_User_Not_AdministrableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_user_not_administrable = /** @type {((inputs?: Error_User_Not_AdministrableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_User_Not_AdministrableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_user_not_administrable(inputs)
});